
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0_488_6229","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"18"}},[_c('path',{attrs:{"d":"M0 0H24V18H0V0Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_488_6229)"}},[_c('path',{attrs:{"d":"M12 5C5.92487 5 1 9.92487 1 16C1 18.6512 1.9379 21.0833 3.5 22.9826H20.5C22.0621 21.0833 23 18.6512 23 16C23 9.92487 18.0751 5 12 5Z","stroke":"#262D33","stroke-width":"2"}})]),_c('path',{staticClass:"fill-white",attrs:{"d":"M10 17C10 18.1046 10.8954 19 12 19C12.6757 19 13.2731 18.6649 13.6352 18.1519L18 11L10.8464 15.366C10.3343 15.7282 10 16.3251 10 17Z","fill":"#262D33"}})])
          )
        }
      }
    